import React from "react";
import SimplePage from "../../shared/SimplePage";

export default function Blog() {
  return <SimplePage title="Blog" />;
}
